// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network_layout__WQkI9 {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
}
.network_mapWrap__AiAtN {
  min-width: 0;
}
.network_map__ZYRE0 {
  width: 100%;
  height: auto;
  display: block;
}
.network_legend__\\+CJoR {
  margin: var(--space-3) 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
.network_dot__q0iJz {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  background: var(--color-ink);
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px var(--color-ink);
}
.network_hq__LKr8P {
  margin-left: var(--space-4);
}

.network_panel__k3qza {
  min-width: 0;
}
.network_states__uMj4t {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-bottom: var(--space-5);
}
.network_stateTab__Qn\\+TS {
  padding: 0.6rem 1.1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-paper);
  font-family: var(--font-sans);
  font-size: 0.95rem;
  cursor: pointer;
  transition: background var(--dur-fast) ease, color var(--dur-fast) ease;
}
.network_stateTab__Qn\\+TS:hover {
  border-color: var(--color-ink);
}
.network_stateTab__Qn\\+TS[aria-selected="true"] {
  background: var(--color-ink);
  color: #fff;
  border-color: var(--color-ink);
}
.network_detail__salxh {
  background: var(--color-paper);
  border-radius: var(--radius-lg);
  padding: clamp(1.25rem, 1rem + 1.5vw, 2.25rem);
  box-shadow: var(--shadow-sm);
  border-top: 4px solid var(--color-accent);
}
.network_stateName__oK5hM {
  margin: 0 0 var(--space-4);
  font-size: var(--text-h2);
  font-weight: 500;
  letter-spacing: var(--tracking-heading);
  line-height: 1.1;
}
.network_facts__aMdl8 {
  margin: 0 0 var(--space-5);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  padding-bottom: var(--space-5);
  border-bottom: 1px solid var(--color-border);
}
.network_facts__aMdl8 dt {
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
.network_facts__aMdl8 dd {
  margin: 0;
  font-size: clamp(1.8rem, 1.4rem + 1.5vw, 2.6rem);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: var(--tracking-figure);
}
.network_chips__Q47hs {
  margin: 0 0 var(--space-5);
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.network_chips__Q47hs li {
  padding: 0.3rem 0.75rem;
  font-size: var(--text-caption);
  background: var(--color-cloud);
  border-radius: var(--radius-pill);
}
.network_cities__8zW1F {
  margin: 0 0 var(--space-5);
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--color-border);
}
.network_city__1RlWN {
  border-bottom: 1px solid var(--color-border);
}
.network_cityBtn__HzJUr {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  padding: 0.95rem 0;
  background: none;
  border: 0;
  font-family: var(--font-sans);
  font-size: 1.05rem;
  text-align: left;
  cursor: pointer;
  color: var(--color-text);
}
.network_cityBtn__HzJUr::after {
  content: "+";
  order: 3;
  font-size: 1.3rem;
  line-height: 1;
  color: var(--color-text-muted);
}
.network_cityBtn__HzJUr[aria-expanded="true"]::after {
  content: "–";
}
.network_count__X00LK {
  margin-left: auto;
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
.network_hqTag__ciY\\+g {
  margin-left: 0.5rem;
  padding: 0.1rem 0.45rem;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 700;
  background: var(--color-accent);
  border-radius: var(--radius-sm);
}
.network_people__WYOVM {
  margin: 0 0 var(--space-3);
  padding: 0 0 0 var(--space-3);
  list-style: none;
  display: grid;
  gap: var(--space-2);
  border-left: 2px solid var(--color-accent);
}
.network_people__WYOVM li {
  display: flex;
  flex-direction: column;
  font-size: 0.95rem;
}
.network_people__WYOVM span {
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}

@media (min-width: 992px) {
  .network_layout__WQkI9 {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    gap: var(--space-7);
  }
  .network_mapWrap__AiAtN {
    position: sticky;
    top: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/NETWORK/network.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,uEAAuE;AACzE;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE;IACE,wDAAwD;IACxD,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".layout {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n}\n.mapWrap {\n  min-width: 0;\n}\n.map {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n.legend {\n  margin: var(--space-3) 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n.dot {\n  width: 0.7rem;\n  height: 0.7rem;\n  border-radius: 50%;\n  background: var(--color-ink);\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 1px var(--color-ink);\n}\n.hq {\n  margin-left: var(--space-4);\n}\n\n.panel {\n  min-width: 0;\n}\n.states {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  margin-bottom: var(--space-5);\n}\n.stateTab {\n  padding: 0.6rem 1.1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  background: var(--color-paper);\n  font-family: var(--font-sans);\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background var(--dur-fast) ease, color var(--dur-fast) ease;\n}\n.stateTab:hover {\n  border-color: var(--color-ink);\n}\n.stateTab[aria-selected=\"true\"] {\n  background: var(--color-ink);\n  color: #fff;\n  border-color: var(--color-ink);\n}\n.detail {\n  background: var(--color-paper);\n  border-radius: var(--radius-lg);\n  padding: clamp(1.25rem, 1rem + 1.5vw, 2.25rem);\n  box-shadow: var(--shadow-sm);\n  border-top: 4px solid var(--color-accent);\n}\n.stateName {\n  margin: 0 0 var(--space-4);\n  font-size: var(--text-h2);\n  font-weight: 500;\n  letter-spacing: var(--tracking-heading);\n  line-height: 1.1;\n}\n.facts {\n  margin: 0 0 var(--space-5);\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-4);\n  padding-bottom: var(--space-5);\n  border-bottom: 1px solid var(--color-border);\n}\n.facts dt {\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n.facts dd {\n  margin: 0;\n  font-size: clamp(1.8rem, 1.4rem + 1.5vw, 2.6rem);\n  font-weight: 500;\n  line-height: 1.1;\n  letter-spacing: var(--tracking-figure);\n}\n.chips {\n  margin: 0 0 var(--space-5);\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n.chips li {\n  padding: 0.3rem 0.75rem;\n  font-size: var(--text-caption);\n  background: var(--color-cloud);\n  border-radius: var(--radius-pill);\n}\n.cities {\n  margin: 0 0 var(--space-5);\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--color-border);\n}\n.city {\n  border-bottom: 1px solid var(--color-border);\n}\n.cityBtn {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 0.95rem 0;\n  background: none;\n  border: 0;\n  font-family: var(--font-sans);\n  font-size: 1.05rem;\n  text-align: left;\n  cursor: pointer;\n  color: var(--color-text);\n}\n.cityBtn::after {\n  content: \"+\";\n  order: 3;\n  font-size: 1.3rem;\n  line-height: 1;\n  color: var(--color-text-muted);\n}\n.cityBtn[aria-expanded=\"true\"]::after {\n  content: \"–\";\n}\n.count {\n  margin-left: auto;\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n.hqTag {\n  margin-left: 0.5rem;\n  padding: 0.1rem 0.45rem;\n  font-size: 0.7rem;\n  font-style: normal;\n  font-weight: 700;\n  background: var(--color-accent);\n  border-radius: var(--radius-sm);\n}\n.people {\n  margin: 0 0 var(--space-3);\n  padding: 0 0 0 var(--space-3);\n  list-style: none;\n  display: grid;\n  gap: var(--space-2);\n  border-left: 2px solid var(--color-accent);\n}\n.people li {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.95rem;\n}\n.people span {\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);\n    gap: var(--space-7);\n  }\n  .mapWrap {\n    position: sticky;\n    top: 6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `network_layout__WQkI9`,
	"mapWrap": `network_mapWrap__AiAtN`,
	"map": `network_map__ZYRE0`,
	"legend": `network_legend__+CJoR`,
	"dot": `network_dot__q0iJz`,
	"hq": `network_hq__LKr8P`,
	"panel": `network_panel__k3qza`,
	"states": `network_states__uMj4t`,
	"stateTab": `network_stateTab__Qn+TS`,
	"detail": `network_detail__salxh`,
	"stateName": `network_stateName__oK5hM`,
	"facts": `network_facts__aMdl8`,
	"chips": `network_chips__Q47hs`,
	"cities": `network_cities__8zW1F`,
	"city": `network_city__1RlWN`,
	"cityBtn": `network_cityBtn__HzJUr`,
	"count": `network_count__X00LK`,
	"hqTag": `network_hqTag__ciY+g`,
	"people": `network_people__WYOVM`
};
export default ___CSS_LOADER_EXPORT___;
